import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Body from "./Body";
import "../Components/css/Phase3.css";
import { useNavigate } from "react-router-dom";
import "../Components/css/loggin.css";
import "../Components/css/SignUp2.css";
import "../Components/css/responsive.css";
import "../Components/css/Varification.css";
// import Chart from "./Chart";

const SignUp_Varification = () => {
  let navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="main-containerr bgclr">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
             <Body/>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <div className="main-form mt-2">
                <div>
                  <div className="Info text-white">
                    <h3 className=" text-white mb-3">RAFFLE MANIA</h3>
                    <p>Varification</p>
                    <p className="mt-2">
                      A 4-digit code is sent to your number. Kindly enter that
                      code here to activate your account. Thanks
                    </p>
                    <form className="mt-3 mb-4">
                      <input
                        type="text"
                        className=" setInputs"
                        placeholder="*"
                      />
                      <input
                        type="text"
                        className=" setInputs"
                        placeholder="*"
                      />
                      <input
                        type="text"
                        className=" setInputs"
                        placeholder="*"
                      />
                      <input
                        type="text"
                        className=" setInputs"
                        placeholder="*"
                      />
                    </form>
                    <p>Resend Confirmation Code (1:08)</p>
                    <div className=" btnDiv3 p-2 ">
                      <button
                        className="btn  w-100 mb-1  bg-white"
                        onClick={() => {
                          navigate(`/NewPassword`);
                        }}
                      >
                        Varification Code
                      </button>
                      <button
                        className=" bg-white btn   w-100 mt-2 "
                        onClick={() => {
                          navigate(`/NewPassword`);
                        }}
                      >
                        Save
                      </button>
                      <p className="text-white pt-4">
                        Already Have an Account?
                        <span>
                          <a
                            className="text-primary"
                            onClick={() => {
                              navigate(`/`);
                            }}
                          >
                            Log In
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div className="mt-1 btnDiv p-2 pl-3">
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn  mt-1 bg-white  signBtn2"
                      onClick={() => {
                        navigate(`/SignUpPhase2`);
                      }}
                    >
                      Previous
                    </button>
                    <button
                      className="btn  mt-1 bg-white signBtn2"
                      onClick={() => {
                        navigate(`/SignUp`);
                      }}
                    >
                      Next
                    </button>
                  </div>

                  <p className="text-white p-3">
                    Already Have an Account?
                    <span>
                      <a
                        className="text-primary"
                        onClick={() => {
                          navigate(`/`);
                        }}
                      >
                        Log In
                      </a>
                    </span>
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignUp_Varification;
